import React from 'react';
import { PROGRESS_BAR_STEPS_TYPE, PROGRESS_BAR_STEP_ENUM } from 'src/components/Checkout/CheckoutProgressBar.config';
import { useMobile } from 'src/hooks/UseResponsive';
import { CircularProgressBar } from './CircularProgressBar/CircularProgressBar';
import { LinearProgressBar } from './LinearProgressBar/LinearProgressBar';

export interface ProgressBarProps {
  steps: PROGRESS_BAR_STEPS_TYPE;
  currentStep: PROGRESS_BAR_STEP_ENUM;
}

export const ResponsiveProgressBar: React.FC<ProgressBarProps> = props => {
  const isMobile = useMobile();

  return (
    <section>
      {
        !isMobile ?
        <LinearProgressBar {...props} />
        :
        <CircularProgressBar {...props} />
      }
    </section>
  );
};

ResponsiveProgressBar.displayName = 'ResponsiveProgressBar';
